<template>
  <div class="emojis">
    <div class="box-emojis-btn">
      <button class="btn-emojis" @click="showEmojis">
        <div class="block-image">
          <img src="@/assets/heureux.png" alt="Emojis heureux"/>
        </div>
      </button>
    </div>
    <div class="container" v-if="isShowEmojis">
      <div class="box-list-emojis">
        <div class="content-list-emojis">
          <div class="list-emojis">
            <ul v-for="(emoji) in emojis" :key="emoji.slug">
              <li @click="getIndex(emoji.character)" class="emoji-icon" style="font-size:20px;">{{emoji.character}}</li>
            </ul>
          </div>
          <button class="btn-close-fixed" @click="showEmojis"><img src="@/assets/icone-close.png" alt="close"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataEmojis from '@/components/emojis/emojis.json'
export default {
  name: 'Emoji',
  data () {
    return {
      emojis: dataEmojis,
      isShowEmojis: false
    }
  },
  methods: {
    showEmojis () {
      this.isShowEmojis = !this.isShowEmojis
    },
    getIndex (emoji) {
      this.$emit('addEmoji', emoji)
    }
  }
}
</script>
<style scoped>
*, ::before, ::after{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.emojis {
  position: relative;
  margin-top: -10px;
}

.btn-emojis {
  border: none;
  background: none;
  outline: none;
}

.container {
  position: absolute;
  top: -10px;
  width: 350px;
  height: 100px;
  right: 40px;
  padding-left: 0px;
  padding-right: 20px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background-color: rgb(255, 255, 255);
  overflow: scroll;
  overflow-x: hidden;
}

.box-emojis-btn{
  margin-right: 15px;
}

.box-list-emojis {
  width: 350px;
  height: 100px;
  position: relative;
}

.content-list-emojis {
  overflow: auto;
  width: 100%;
  height: 100%;
}

.btn-close-fixed {
  position: absolute;
  top: -10px;
  right: 5px;
  background: none;
  border: none;
  outline: none;
  margin-right: 10px;
}

.btn-close-fixed img{
  width: 20px;
}

.content-list-emojis ul {
  list-style-type: none;
  cursor: pointer;
  margin: 0 0 0 10px;
}

.list-emojis {
  width: 250px;
  display: grid;
  grid-template-columns: 50px 50px 50px 50px 50px;
  grid-template-rows: auto;
  column-gap: 10px;
  row-gap: 10px;
  margin-bottom: 20px;
}

.block-image {
  width: 25px;
  height: 25px;
  box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
  border-radius: 5px;
  position: relative;
}

.block-image img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
}

</style>
